export default __webpack_public_path__ + "static/media/miguel-lopes-25.be83c93e.jpg";